<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12 pa-2" sm="4">
          <v-card class="mx-auto" color="primary" dark >
            <v-card-title>
              <v-icon large left>{{mdiNumeric}}</v-icon>
              <span class="text-h6">Fibonacci vote</span>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text class="white--text">
              Estimate with the classic fibonacci series.
            </v-card-text>
          </v-card>
      </v-col>
      <v-col cols="12 pa-2" sm="4">
          <v-card class="mx-auto" color="primary" dark >
            <v-card-title>
              <v-icon large left>{{mdiTshirtCrew}}</v-icon>
              <span class="text-h6 ">T-shirt vote</span>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text class="white--text">
              You need also the tshirt size? You have it.
            </v-card-text>
          </v-card>
      </v-col>
      <v-col cols="12 pa-2" sm="4">
          <v-card class="mx-auto" color="primary" dark >
            <v-card-title>
              <v-icon left>{{mdiThumbUp}}</v-icon>
              <span class="text-h6">Thumbs up/down vote</span>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text class="white--text  ">
              At the end of the meeting use the thumbs up vote to see if the outcome is affordable. 
            </v-card-text>
          </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiTshirtCrew, mdiThumbUp, mdiNumeric } from '@mdi/js'

export default {
  data () {
    return {
      mdiTshirtCrew,
      mdiThumbUp,
      mdiNumeric
    }
  }
}
</script>